import builder from '../builder';
import DrawerOpen from '../../streamline-icons/light/drawer-open.svg';

export default builder('IconDrawerOpenLight', DrawerOpen);
